export default `
    # if (data.isPopUpChild) { #
        <div id="#= data.id #" screenentitytype="#= data.ScreenEntityType #">
            <div>
                #= data.components #
            </div>
            <div class="popup-button-container col-xs-12">
                #= data.popUpOnlyActions #
                #= data.actions #
            </div>
        </div>
    # } else { #
        <div class="pane-container #= data.containerClasses # #=data.bsc||""#" id="#= data.id #" screenentitytype="#= data.ScreenEntityType #">
            <div class="pane">
                <div class="pane-header">
                    <span class="pane-title #=data.bindClass#" data-bind="text: #= data.title #">
                    </span>
                    # if (data.info) {#
                        <span class="pane-tooltip-info mar-l-5" id="#= data.id #_info"></span>
                    # } #
                    <span class="pane-other-info">
                        #= (data.otherInfo ? data.otherInfo : "") #
                    </span>
                    # if (data.count) {#
                        <span class="count mar-l-5">
                            <span>
                                <span class="bind-value" data-bind="countText: #= data.bindValue #">
                                </span>
                            </span>
                        </span>
                    # } #
                    <span class="pane-options right">
                        # if (data.print) { #
                            <span class="print">
                            </span>
                        # } #
                        # if (data.gear) { #
                            <span class="gear">
                            </span>
                        # } #
                        # if (data.minimize) { #
                            <span class="k-icon k-i-window-minimize">
                            </span>
                        # } #
                        # if (data.expand) { #
                            <span class="expand">
                            </span>
                        # } #
                    </span>
                </div>
                <div class="pane-body container #= data.classes #">
                    #= data.components #
                </div>
            </div>
            <div class="action-column">
                #= data.actions #
            </div>
        </div>
    # } #
`;
